import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from 'components/shared/Typography'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'

interface IProps {
  currentPath: string
  logOut: () => void
  paths: any
}

const Menu = ({ paths, currentPath, logOut }: IProps): JSX.Element => (
  <Grid container item alignItems="center">
    {paths.map(({ link, name }) => (
      <Grid item key={link}>
        <Link to={link}>
          <Typography variant="h4" color="primary">
            <Box
              mx={1.5}
              style={{
                borderBottom: link === currentPath ? 'solid 1px #fff' : 'none',
              }}
            >
              {name}
            </Box>
          </Typography>
        </Link>
      </Grid>
    ))}
    <Grid item>
      <Box ml={2}>
        <Button onClick={logOut} variant="contained" color="primary">
          <Typography variant="h4" color="secondary">
            <Box p={1}>Logout</Box>
          </Typography>
        </Button>
      </Box>
    </Grid>
  </Grid>
)

export default Menu
